import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { Location } from "@angular/common";

@Component({
  selector: "app-feedback-success",
  templateUrl: "./feedback-success.component.html",
  standalone:false,
  styleUrls: ["./feedback-success.component.scss"],
})
export class FeedbackSuccessComponent implements OnInit {
  constructor(private router: Router) {}

  ngOnInit(): void {}

  done() {
    this.router.navigateByUrl("/ReachUs");
  }

}